import { useCallback, useEffect, useState } from "react";
import { ISelectOptions } from "../../../types/inputs";
import { Motivo } from "../../../services/Motivo";
import { TipoMotivoEnum } from "../../../enums/motivo";
import { useContextSite } from "../../../context/Context";
import { useNavigate, useParams } from "react-router-dom";
import { IRegistroOcorrenciaForm } from "../../../types/registroOcorrencia";
import { RegistroOcorrencia } from "../../../services/RegistroOcorrencia";
import { toast } from "react-toastify";

export const useDelayNotification = () => {
    const [motivosOptions, setMotivosOptions] = useState<ISelectOptions[]>([] as ISelectOptions[]);
    const { setIsLoad } = useContextSite();
    const { uuidAgendamento } = useParams();
    const navigate = useNavigate();
    const [form, setForm] = useState<IRegistroOcorrenciaForm>({
        uuidAgendamento: uuidAgendamento || "",
        outroMotivo: false
    })

    const getMotivos = useCallback(async () => {
        Motivo.list({ tipo: TipoMotivoEnum.ATRASO }).then(({ data }) => {
        const options = data.content.map((i) => ({
            value: i.uuid,
            label: i.descricao,
        }));
        setMotivosOptions(options);
    });
    }, []);

    useEffect(() => {
        getMotivos();
    }, []);

    function submitForm(data: IRegistroOcorrenciaForm) {
        setIsLoad(true);

        const PAYLOAD: IRegistroOcorrenciaForm = {
            ...data,
            uuidAgendamento: uuidAgendamento,
        }

        RegistroOcorrencia.comunicarAtraso(PAYLOAD)
        .then(() => {
            toast.success("Atraso comunicado com sucesso!");
            navigate(`/meus-agendamentos/agendamento?id=${uuidAgendamento}`);
        })
        .catch(
        ({
            response: {
                data: { mensagem },
            },
            }) => toast.error(mensagem)
        )
        .finally(() => setIsLoad(false)); 
    } 

    return {
        motivosOptions,
        submitForm,
        form,
        setForm,
    };
};